//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { TABLET, MOBILE } from '@/scripts/constants/media-query'

export default {
  name: 'rb-promo-toggle',
  props: {
    isActive: {
      type: Boolean,
      default: undefined,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isHover: false,
    }
  },
  computed: {
    ariaLabel() {
      return this.loading ? 'Promo Toggle Loading' : `Promo toggle ${this.$slots.label?.[0]?.text}`
    },
    isMobileOrTablet() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
  },
  methods: {
    toggleActiveStatus() {
      this.$emit('click')
    },
  },
}
